<template>
  <VoteBase>
    <template v-slot:voteMain>
      <div>
        <b-card>
          <div slot="header">
            <b-button :to="{name: 'vote-list', params: {oversea: !!JSON.parse($route.query.oversea)}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
            用户累计投票奖励{{ appName ? '【' + appName + '】' : '' }}{{ !!JSON.parse($route.query.oversea) ? overseaTag : '' }}
          </div>
          <b-button variant="outline-primary" :style="{marginBottom: '18px'}" @click="addOneReward()">添加奖励项</b-button>
          <b-button size="sm" variant="link" :style="{marginBottom: '18px'}" @click="refresh()"><i class="fa fa-refresh" /></b-button>
          <b-table class="text-center" show-empty responsive="sm" :busy="items === null" :items="items" :fields="fields" :current-page="currentPage" :emptyText="tableEmptyText">
            <template #cell(vote_number)="data">
              <template v-if="data.item.disabled">
                {{ data.item.vote_number }}
              </template>
              <template v-else>
                <b-form-input
                  type="number"
                  v-model="data.item.vote_number"
                  :disabled="data.item.disabled"
                  min="1"
                  required
                />
              </template>
            </template>
            <template #cell(reward_type)="data">
              <b-form-checkbox
                switch
                v-model="data.item.reward_type"
                @change="changeRewardType(data.index)"
                required
                :disabled="data.item.disabled"
              />
            </template>
            <template #cell(prize)="data">
              <template v-if="data.item.disabled">
                <template v-for="(item, idx) in data.item.prize">
                  <b-button :key="idx" variant="light" class="prize" disabled>
                    {{ item.name }} <b-badge variant="danger" pill>{{ item.number }}</b-badge>
                  </b-button>
                </template>
              </template>
              <template v-else v-for="(item, idx) in data.item.prize">
                <b-form :key="idx" inline class="prize-form">
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0 prize-name"
                    placeholder="奖励名称"
                    v-model="item.name"
                  />
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    type="text"
                    min="1"
                    placeholder="数量"
                    v-model="item.number"
                    :disabled="!data.item.reward_type"
                  />
                  <b-button v-if="idx === 0" size="sm" variant="outline-primary" @click="addPrizeRow(data.index)">Add</b-button>
                  <b-button v-else size="sm" variant="outline-danger" @click="deletePrizeRow(data.index, idx)">Delete</b-button>
                </b-form>
              </template>
            </template>
            <template #cell(receive_num)="data">
              <template v-if="data.item.disabled">
                {{ data.item.receive_num }}
              </template>
              <template v-else>
                <b-form-input
                  type="number"
                  v-model="data.item.receive_num"
                  :disabled="data.item.disabled"
                  min="1"
                  required
                />
              </template>
            </template>
            <template #cell(op)="data">
              <template v-if="data.item.disabled">
                <b-button size="sm" variant="outline-warning" :style="{marginBottom: '18px'}" @click="edit(data.index)">
                  <i class="fa fa-edit" /> 编辑
                </b-button>
                <b-button size="sm" variant="outline-danger" :style="{marginBottom: '18px'}" @click="deleteTip(data.index)">
                  <i class="fa fa-trash-o" /> 删除
                </b-button>
              </template>
              <template v-else>
                <b-button size="sm" variant="outline-success" :style="{marginBottom: '18px'}" @click="save(data.index, data.item.new)">
                  <i class="fa fa-save" /> 保存
                </b-button>
                <b-button size="sm" variant="outline-warning" :style="{marginBottom: '18px'}" @click="cancel(data.index, data.item.new)">
                  <i class="fa fa-save" /> 取消
                </b-button>
              </template>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
                <strong>加载中...</strong>
              </div>
            </template>
          </b-table>
          <nav>
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="<<"
              next-text=">>"
              @change="changePage"
              hide-goto-end-buttons
              first-number
              last-number
            />
          </nav>
        </b-card>
        <TipModal ref="tip" :tipData="tipData">
          <template v-slot:footer>
            <b-button size="sm" variant="outline-dark" @click="cancelDelete()" >取消</b-button>
            <b-button size="sm" variant="outline-danger" @click="del()" >删除</b-button>
          </template>
        </TipModal>
      </div>
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import VoteBase from './Base'
import TipModal from '@/components/TipModal'

export default {
  name: 'vote-reward',
  mixins: [Error],
  components: {VoteBase, TipModal},
  data () {
    return {
      items: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      fields: consts.VOTE_REWARD_FIELDS,
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      addItems: [],
      editingId: [],
      appName: '',
      tipData: {
        data: null,
        title: '',
        msg: '',
        headerBgVariant: '',
        headerTextVariant: ''
      },
      overseaTag: consts.overseaTag
    }
  },
  created () {
    api.voteHandler(this, api.getVoteDetail(), 'GET', {app_id: this.$route.params.appId}, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getAppName)
    this.getItems()
  },
  methods: {
    getItems () {
      let params = {
        app_id: this.$route.params.appId
      }
      api.fetchVoteListData(this, api.getVoteRewardList(), 'reward_list', params, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.handleData)
    },
    handleData (data) {
      for (let idx in data['reward_list']) {
        data['reward_list'][idx].disabled = true
        data['reward_list'][idx].reward_type = !!data['reward_list'][idx].reward_type
      }
      this.items = data['reward_list']
      this.totalRows = data['total_num']
      if (this.addItems.length > 0) {
        for (let i = this.addItems.length - 1; i >= 0; i--) {
          this.items.unshift(JSON.parse(JSON.stringify(this.addItems[i])))
        }
        this.addItems = []
      }
      if (this.editingId.length > 0) {
        for (let i in this.items) {
          if (this.items[i].hasOwnProperty('id') && this.editingId.indexOf(this.items[i].id) !== -1) {
            this.items[i].disabled = false
          }
        }
        this.editingId = []
      }
    },
    getAppName (res) {
      this.appName = res.data.app_name
    },
    addOneReward () {
      this.items.unshift(JSON.parse(JSON.stringify(consts.VOTE_REWARD_BASE_DATA)))
    },
    refresh () {
      this.getItems()
    },
    save (idx, isNew) {
      if (!this.items[idx].vote_number) {
        this.$message.error('票数不能为空')
        return false
      }
      let reg = /^[1-9]+[0-9]*]*$/
      if (this.items[idx].reward_type && !reg.test(this.items[idx].vote_number)) {
        this.$message.error('票数必须为正整数')
        return false
      }
      let prizeNameList = []
      for (let i in this.items[idx].prize) {
        let name = this.items[idx].prize[i].name
        let number = this.items[idx].prize[i].number
        if (!name && number) {
          this.$message.error('奖励名称不能为空')
          return false
        }
        if (name.indexOf('=') !== -1 || name.indexOf('/') !== -1) {
          this.$message.error('奖励名称不能包含"="、"/"等字符')
          return false
        }
        if (this.items[idx].reward_type && !number && name) {
          this.$message.error('奖励数量不能为空')
          return false
        }
        if (this.items[idx].reward_type && number && !reg.test(number)) {
          this.$message.error('奖励数量必须为正整数')
          return false
        }
        if (prizeNameList.includes(name)) {
          this.$message.error('奖励不可重复')
          return false
        } else {
          prizeNameList.push(name)
        }
      }
      if (!this.items[idx].reward_type) {
        for (let i in this.items[idx].prize) {
          this.items[idx].prize[i].number = -1
        }
      }
      this.getEditingItem(idx)
      let submitData = null
      if (isNew) {
        submitData = this.handleSaveData(this.items[idx])
      } else {
        submitData = this.handleSaveData(this.items[idx], true)
      }
      if (submitData) {
        if (isNew) {
          api.createVoteData(this, api.getVoteRewardCreate(), 'POST', submitData, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getItems)
        } else {
          api.updateVoteData(this, api.getVoteRewardUpdate(), 'POST', submitData, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getItems)
        }
      } else {
        return false
      }
    },
    getEditingItem (idx) {
      for (let i in this.items) {
        if (this.items[i].new && Number(i) !== Number(idx)) {
          this.addItems.unshift(this.items[i])
        }
        if (!this.items[i].new && !this.items[i].disabled && Number(i) !== Number(idx)) {
          this.editingId.push(this.items[i].id)
        }
      }
    },
    edit (idx) {
      this.items[idx].disabled = false
    },
    cancel (idx, isNew) {
      if (isNew) {
        this.items.splice(idx, 1)
      } else {
        this.getEditingItem(idx)
        this.getItems()
      }
    },
    del () {
      api.updateVoteData(this, api.getVoteRewardDelete(), 'POST', this.$refs.tip.modalData.data, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.delCallback)
    },
    delCallback () {
      this.$refs.tip.modalHide()
      this.getItems()
    },
    changePage (page) {
      this.currentPage = page
      this.getItems()
    },
    handleSaveData (data, isUpdate = false) {
      let prize = []
      for (let i in data.prize) {
        if (data.prize[i].name && data.prize[i].number) {
          prize.push(data.prize[i])
        }
      }
      if (prize.length === 0) {
        this.$message.error('奖励不能为空')
        return false
      }
      if (!data.receive_num) {
        this.$message.error('可领个数不能为空')
        return false
      }
      let reg = /^[1-9]+[0-9]*]*$/
      if (!reg.test(data.receive_num)) {
        this.$message.error('可领个数必须为正整数')
        return false
      }
      if (data.receive_num > prize.length) {
        this.$message.error('可领个数不能超过奖励数')
        return false
      }
      let newData = {
        app_id: this.$route.params.appId,
        reward_list: [{
          vote_number: data.vote_number,
          reward_type: data.reward_type ? 1 : 0,
          prize: prize,
          receive_num: data.receive_num
        }]
      }
      if (isUpdate) {
        newData.reward_list[0].id = data.id
      }
      return newData
    },
    addPrizeRow (index) {
      this.items[index].prize.push({ name: '', number: '' })
    },
    deletePrizeRow (index, prizeIdx) {
      this.items[index].prize.splice(prizeIdx, 1)
    },
    changeRewardType (idx) {
      if (this.items[idx].reward_type) {
        for (let i in this.items[idx].prize) {
          this.items[idx].prize[i].number = ''
        }
      }
    },
    deleteTip (idx) {
      this.tipData = {
        data: {app_id: this.$route.params.appId, reward_id: this.items[idx].id},
        title: '警告',
        msg: '是否确定删除 累积投票数=' + this.items[idx].vote_number + ' 的奖励项？',
        headerBgVariant: 'danger',
        headerTextVariant: 'light'
      }
      this.$refs.tip.modalShow()
    },
    cancelDelete () {
      this.$refs.tip.modalHide()
    }
  }
}
</script>

<style>
  .prize-form {
    margin-bottom: 2px;
  }
  .prize-name {
    width: 50% !important;
  }
  .prize {
    margin-right: 5px;
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// VoteReward.vue?42676108